/** Pure: shared by edge functions and the CRM invoice preview. */
export type BillToCandidate = {
  id: number | string;
  email_jsonb?: unknown;
};

const emailsOf = (candidate: BillToCandidate) =>
  Array.isArray(candidate.email_jsonb)
    ? candidate.email_jsonb
        .map((row) =>
          typeof row?.email === "string" ? row.email.trim().toLowerCase() : "",
        )
        .filter(Boolean)
    : [];

/**
 * Who an invoice is billed to, from the recipients chosen for the send:
 * the first recipient that belongs to exactly one known contact. A typed
 * address of nobody bills the account (null) — not the ticket's requester.
 * Without an account, the default contact stays so the invoice keeps a client.
 * No recipients: keep the default contact.
 */
export const pickBillToContactId = ({
  recipients,
  candidates,
  defaultContactId,
  hasAccount,
}: {
  recipients: string[];
  candidates: BillToCandidate[];
  defaultContactId: number | string | null | undefined;
  hasAccount: boolean;
}): number | string | null => {
  const wanted = recipients
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
  if (!wanted.length) return defaultContactId ?? null;
  for (const email of wanted) {
    const owners = candidates.filter((candidate) =>
      emailsOf(candidate).includes(email),
    );
    if (owners.length === 1) return owners[0].id;
  }
  return hasAccount ? null : (defaultContactId ?? null);
};
